<app-collapsible-section heading="Entity Assignments" [count]="dataSource.data.length">
  @if (defaults.isMersyAdminBranchExcellenceUser) {
    <div section-actions class="OrangeButton section-buttons">
      @if (!isRemoveAssignmentEnabled) {
        <button mat-raised-button (click)="openAssignBranchPopup()"
          title="Assign new entities" class="btn btn-sm button-color-fix">
          Add Entity <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
        </button>
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Unassign entities from this wave" class="btn btn-sm button-color-fix">
          Unassign <mat-icon class="add-button icon-color-fix">remove_circle</mat-icon>
        </button>
      } @else {
        <button mat-raised-button (click)="enableRemoveAssignmentMode()"
          title="Close unassignment mode" class="btn btn-sm button-color-fix">
          Close <mat-icon class="add-button icon-color-fix">close</mat-icon>
        </button>
      }
    </div>
  }

  <div class="admin-table-scroll mat-elevation-z8">
    <table mat-table #itemsList
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="mat-table-custom assignment-table">

      <ng-container matColumnDef="Checkbox">
        <th mat-header-cell *matHeaderCellDef>
          @if (isRemoveAssignmentEnabled) {
            <mat-checkbox class="select-all-checkbox"
              matTooltip="Select All"
              (click)="$event.stopPropagation();"
              (keydown)="$event.stopPropagation();"
              [checked]="isAllSelected()"
              [indeterminate]="isPartiallySelected()"
              (change)="controlAssignedItem($event.checked)">
              Select All
            </mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let element">
          @if (isRemoveAssignmentEnabled) {
            <mat-checkbox (click)="$event.stopPropagation();" (keydown)="$event.stopPropagation();"
              [checked]="removeBranchesList.includes(element.MgmtId)"
              (change)="controlAssignedItem($event.checked, element)">
            </mat-checkbox>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="MgmtId">
        <th mat-header-cell *matHeaderCellDef> Entity Id </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.MgmtId"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="MgmtName">
        <th mat-header-cell *matHeaderCellDef> Entity Name </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.MgmtName"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="AssessmentDate">
        <th mat-header-cell *matHeaderCellDef> Assessment Date </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.AssessmentDate"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="ChangeLog">
        <th mat-header-cell *matHeaderCellDef>Change Log</th>
        <td mat-cell *matCellDef="let element">
          <compact-history-button
            [item]="element"
            tooltip="View Change Log"
            buttonText="Get History"
            (historyClick)="onHistoryDetail($event, 'AssesmentAssignment')">
          </compact-history-button>
        </td>
      </ng-container>

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
        class="item">
      </tr>
    </table>
  </div>

  @if (isRemoveAssignmentEnabled && defaults.isMersyAdminBranchExcellenceUser) {
    <div class="stickybottompanel">
      @if (removeBranchesList.length > 0) {
        <div class="col-lg-6" style="width:50%">
          Total selected entities : {{removeBranchesList.length}}
        </div>
        <button class="btn btn-realease btn-sm pull-right button-margin" (click)="confirmRemoveAssignedBranches()">
          Confirm
        </button>
      } @else {
        <div class="col-lg-6" style="width:50%">
          Please select at least one Entity
        </div>
      }
    </div>
  }
</app-collapsible-section>
